/* eslint-disable */
//Strange elint error. Says className,type, text and events are missing prop validation.  But they aren't.
import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";
import { areEqualShallow } from "Utils/areEqual";
import { LeftArrow, NextArrowIcon } from "./Arrows";
import CloseIcon from "./Close";
import DirectionsIcon from "./Directions";
import TrailsIcon from "./Trails";
import DestinationsMobileIcon from "./DestinationsMobile";
import styles from "../Destinations/styles";


interface Props {
  className?: string;
  events?: any;
  text?: any;
  type: string;
  tabIndex?: number;
}

const Icon: FC<Props> = memo(({ className, type, text, events, tabIndex }: Props) => {
  const useStyles = createUseStyles(styles);
  const classes = useStyles();
  return {
    leftarrow: <LeftArrow {...events} className={className} />,
    trails: <button id="trails-button" className={classes.button} tabIndex={tabIndex} aria-label="Trails" {...events}><TrailsIcon {...events} className={className} /> </button>,
    directions:<button className={classes.button} tabIndex={tabIndex} aria-label="Directions" {...events}> <DirectionsIcon {...events} className={className} /> </button>,
    close: <button id="close-button" className={classes.button} tabIndex={tabIndex} aria-label="Close" {...events} > <CloseIcon {...events}  className={className} /></button>,
    currentLabel: (
      <button id="current-label-button" type="button" {...events} className={className} style={{ whiteSpace: "nowrap" }}>
        {text}
      </button>
    ),
    textLabel: <div className={classes.button} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "110px"}}>{text}</div>,
    destinationsMobile: (
      <DestinationsMobileIcon {...events} className={className} />
    ),
    nextArrow: <NextArrowIcon {...events} className={className} />,
  }[type];
}, areEqualShallow);
Icon.defaultProps = {
  className: undefined,
  events: undefined,
  text: undefined,
  tabIndex: 0,
};
export default Icon;
